<script>
import baseList from "@/views/components/base/baseList.vue";
import { Tag, Button } from "view-design";
import listRecord from "./listRecord.vue";
import addRecord from "./addRecord.vue";
import config from "@/../config";

export default {
  extends: baseList,
  components: { listRecord, addRecord },
  data() {
    return {
      table: {
        mname: "copyAccounts",
        key: "id",
        url: {
          list: "/admin/system/facility/meterReadingList",
          //   del: "/admin/system/facility",
        },
        output: false,
        order: "id",
        qrCode: "qrCode",
      },
      menus: [],
      query: {},
      actions: [],
      filters: [
        {
          label: "型号",
          KeyEnter: this.search,
          name: "facilityType",
          value: "",
          type: "input",
        },
        {
          label: "资产归属",
          name: "assetOwnership",
          KeyEnter: this.search,
          value: "",
          type: "input",
        },
        {
          label: "资产编号",
          KeyEnter: this.search,
          name: "assetNum",
          value: "",
          type: "input",
        },
      ],
      tableCols: [
        {
          type: "selection",
          width: 60,
        },
        {
          title: "资产编号",
          key: "assetNum",
          width: 100,
          align: "center",
          tooltip: "true",
        },
        {
          title: "二维码",
          width: 80,
          align: "center",
          key: "qrCode",
          viewimage: true,
        },
        {
          title: "型号",
          minWidth: 150,
          align: "center",
          key: "facilityType",
          tooltip: "true",
        },
        {
          title: "类型",
          key: "typeName",
          minWidth: 120,
          align: "center",
          tooltip: "true",
        },
        {
          title: "核算科室",
          key: "checkDeskName",
          minWidth: 150,
          align: "center",
          tooltip: "true",
        },
        {
          title: "使用科室",
          key: "deskName",
          minWidth: 150,
          align: "center",
          tooltip: "true",
        },
        {
          title: "物理地址",
          minWidth: 150,
          align: "center",
          tooltip: "true",
          render: (h, params) => {
            const row = params.row;
            return (
              <div>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content={
                    (row.buildingName ? row.buildingName + "-" : "") +
                    (row.floorName ? row.floorName + "-" : "") +
                    (row.room ? row.room : "")
                  }
                  placement="bottom"
                >
                  <div style="width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                    {" "}
                    {row.buildingName ? row.buildingName + "-" : ""}
                    {row.floorName ? row.floorName + "-" : ""}
                    {row.room ? row.room : ""}
                  </div>
                </el-tooltip>
              </div>
            );
          },
        },
        {
          title: "最新抄张人",
          minWidth: 80,
          key: "meterReadingPerson",
          align: "center",
        },
        {
          title: "最新抄张时间",
          width: 170,
          key: "meterReadingTime",
          align: "center",
        },
        {
          title: "操作",
          align: "center",
          width: 220,
          key: "handle",
          fixed: "right",
          handle: [
            (vm, h, currentRow, param) => {
              // let directives = [];
              return (
                <Button
                  size="small"
                  onClick={() => this.goAccountRecord(currentRow)}
                  type="default"
                  style="border: none;color: #4991ff;"
                >
                  抄张
                </Button>
              );
            },
            (vm, h, currentRow, param) => {
              // let directives = [];
              return (
                <Button
                  size="small"
                  onClick={() => this.toInfo(currentRow)}
                  type="default"
                  style="border: none;color: #4991ff;margin-left: 5px;"
                >
                  抄张记录
                </Button>
              );
            },
            (vm, h, currentRow, param) => {
              // let directives = [];
              return (
                <Button
                  size="small"
                  onClick={() => this.removeItem(currentRow)}
                  type="default"
                  style="border: none;color: #4991ff;margin-left: 5px;"
                >
                  移除
                </Button>
              );
            },
          ],
        },
      ],
      // paperTypeList: [],
    };
  },
  created() {},
  methods: {
    toInfo(row) {
      this.$Modal.success({
        closable: true,
        title: "抄张记录",
        width: "1200px",
        height: "900px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return <listRecord inventoryId={row.id}></listRecord>;
        },
      });
    },
    removeItem(row) {
      let q = {};
      q.facilityIds = [row.id];
      $utils.api
        .load(
          "/admin/system/facility/updateFacilityToNonMeterReading",
          q,
          "post"
        )
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            $utils.toast.success(res.msg);
            this.search();
          }
        });
    },
    goAccountRecord(row) {
      $utils.url.push({
        name: "copy_accounts_edit",
        query: { action: "edit", kv: row.id },
      });
      // this.getPaperTypeList();
      // this.$Modal.success({
      //   closable: true,
      //   title: "抄张",
      //   width: "1200px",
      //   height: "900px",
      //   okText: "取消",
      //   showOk: false,
      //   render: (h) => {
      //     return (
      //       <addRecord
      //         paperTypeList={this.paperTypeList}
      //         facilityId={row.id}
      //         vOn:searchFun={this.searchFun}
      //       ></addRecord>
      //     );
      //   },
      // });
    },

    searchFun() {
      this.search();
    },
  },
};
</script>
<style scoped></style>
